import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.manage-account.change-owner', {
        url: '/change-owner',
        component: 'companyUserDirectoriesManageAccountChangeOwner',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/owner/manage-account-owner.state.js